import React,{useState, useEffect} from 'react'
import ApplicationsData from "../../../../Datas/Applications.json"
import { CgArrowLeft } from 'react-icons/cg'
// import RippleButton from '../../../../components/Buttons/RippleButton'
import { BiFilter } from 'react-icons/bi'
import ico from "../../../../../assets/searchIcon/search.svg"
import user1 from "../../../../../assets/users/leslie-livingston.png"
// import Dropdown from "../../../../../../components/Dropdown/Dropdown"
import DropdownStatus from '../../../../../../components/Dropdown/DropdownStatus'
import { Link, useNavigate, useOutletContext } from 'react-router-dom'
import { GoLocation, GoTriangleUp } from 'react-icons/go'
import DropdownStatusOpt from "../../../../../../components/Dropdown/DropdownStatusOpt"
import { END_POINT } from '../../../../../../utils/constant'
import ImageWithFallback from '../../../../../components/ImageWithFallback'
import StatusBadge from '../../../../../components/StatusBadge'
import { formatInDate } from '../../../../../../components/DateTimeConverter/DateTimeConverter'
import { FaEye } from 'react-icons/fa'
import DeclineEnrollmentModal from './Modals/DeclineEnrollmentModal'
import ConfirmEnrollmentModal from './Modals/ConfirmEnrollmentModal'
import StudentModal from './Modals/StudentModal'
import dayjs from "dayjs";
import { GrUpdate } from 'react-icons/gr'


const Enrollement = ({data}) => {
    const [tasks, setTasks] = useState([])
    const [showStatusModal, setShowStatusModal] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState(null)
    const navigate = useNavigate()
    const {showScroll, setshowScroll} = useOutletContext()
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showModal, setshowModal] = useState(false)
    const [enrolmentSelected, setEnrolmentSelected] = useState({})

    const [openDropdown, setOpenDropdown] = useState(null);
    // const [selectedValues, setSelectedValues] = useState({
    //   week: "This Week",
    //   filter: "Filter",
    //   sort: "Sort",
    // });
    const [filters, setFilters] = useState({
      keyword: "",
      status: "",
      dateRange: "",
      sort: "",
    });

    const handleSelect = (filterType, value) => {
      setFilters((prev) => ({ ...prev, [filterType]: value }));
    };
    
    const handleSearch = (e) => {
      setFilters((prev) => ({ ...prev, keyword: e.target.value }));
    };
    
    
  
    const toggleDropdown = (menu) => {
      setOpenDropdown(openDropdown === menu ? null : menu);
    };

    useEffect(() => {
        // Fetch data from JSON or API
      //   axios.get('../../datas/Applications.json')
      //     .then(response => {
      //       setTasks(response.data)
      //     })
      //     .catch(error => {
      //       console.error("Error fetching tasks data:", error);
      //     })
      setTasks(ApplicationsData)
      }, [])

      const setStatusOption = (status) => {
        setSelectedStatus(status) 
        setshowScroll(false)

        toggleModal(status)
        
      };

      const toggleModal = (modalName) => {
        switch (modalName) {
          case 0:
            setShowConfirmModal((prevState) => !prevState);
            break;
          case 1:
            setShowDeclineModal((prevState) => !prevState);
            break;
        }
      }

 

      const filteredData = data?.enrolments
      .filter((item) =>
        filters.keyword
          ? item.comment.toLowerCase().includes(filters.keyword.toLowerCase()) ||
            item.user.nom.toLowerCase().includes(filters.keyword.toLowerCase())
          : true
      )
      .filter((item) =>
        filters.status ? item.status === filters.status : true
      )
      .filter((item) => {
        if (!filters.dateRange) return true;
        const createdAt = dayjs(item.created_at);
    
        switch (filters.dateRange) {
          case "Aujourd'hui":
            return createdAt.isSame(dayjs(), "day");
          case "Cette semaine":
            return createdAt.isSame(dayjs(), "week");
          case "Ce mois-ci":
            return createdAt.isSame(dayjs(), "month");
          default:
            return true;
        }
      })
      .sort((a, b) => {
        if (filters.sort === "Ordre croissant" || filters.sort === "Date ancien") {
          return dayjs(a.created_at).isAfter(dayjs(b.created_at)) ? 1 : -1;
        } else if (
          filters.sort === "Ordre décroissant" ||
          filters.sort === "Date récent"
        ) {
          return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? 1 : -1;
        } else if (filters.sort === "Alphabétique") {
          return a.user.nom.localeCompare(b.user.nom);
        }
        return 0;
      });
    

  return (
    <div className=''>


        <div className=" flex justify-between items-center mb-4">
            <h4 className='font-semibold whitespace-nowrap'>Historique des inscriptions</h4>
            <div className="flex flex-wrap gap-2 justify-end w-full">
    {/* Barre de recherche */}
    <div className="relative flex items-center w-60 h-10 rounded-lg overflow-hidden border">
      <div className="grid place-items-center h-full w-12 text-gray-300">
        <img src={ico} alt="bouton de recherche" />
      </div>
      <input
        className="peer h-full w-full outline-none text-sm text-gray-700 pr-2"
        type="text"
        id="search"
        placeholder="Rechercher un mot-clé..."
        onChange={(e) => handleSelect("keyword", e.target.value)}
      />
    </div>

    <Dropdown
        label={filters.dateRange || "Date"}
        icon={<CalendarIcon />}
        isOpen={openDropdown === "dateRange"}
        onToggle={() => toggleDropdown("dateRange")}
      >
        <DropdownItem
          text="Aujourd'hui"
          onClick={() => handleSelect("dateRange", "Aujourd'hui")}
        />
        <DropdownItem
          text="Cette semaine"
          onClick={() => handleSelect("dateRange", "Cette semaine")}
        />
        <DropdownItem
          text="Ce mois-ci"
          onClick={() => handleSelect("dateRange", "Ce mois-ci")}
        />
      </Dropdown>

      {/* Filtre par état */}
      <Dropdown
        label={filters.status || "État"}
        icon={<FilterIcon />}
        isOpen={openDropdown === "status"}
        onToggle={() => toggleDropdown("status")}
      >
        <DropdownItem
          text="En attente"
          onClick={() => handleSelect("status", "En attente")}
        />
                <DropdownItem
          text="Accepté"
          onClick={() => handleSelect("status", "Accepté")}
        />
        <DropdownItem
          text="Refusé"
          onClick={() => handleSelect("status", "Refusé")}
        />
      </Dropdown>

      <Dropdown
        label={filters.sort || "Tri"}
        icon={<SortIcon />}
        isOpen={openDropdown === "sort"}
        onToggle={() => toggleDropdown("sort")}
      >
        <DropdownItem
          text="Ordre croissant"
          onClick={() => handleSelect("sort", "Ordre croissant")}
        />
        <DropdownItem
          text="Ordre décroissant"
          onClick={() => handleSelect("sort", "Ordre décroissant")}
        />
        <DropdownItem
          text="Date ancien"
          onClick={() => handleSelect("sort", "Date ancien")}
        />
        <DropdownItem
          text="Date récent"
          onClick={() => handleSelect("sort", "Date récent")}
        />
      </Dropdown>

      <button
      onClick={()=>setFilters({...filters,   keyword: "", status: "", dateRange: "", sort: "",})}
      className="flex items-center space-x-2 px-4 py-2 border rounded-lg bg-white shadow-sm hover:bg-gray-100"
    >
     <GrUpdate></GrUpdate>
    </button>
  </div>
        </div>

      {/* Tableau */}
      <div className="w-full pb-28 lg:w-[100%] xl:w-[900px] min-[1300px]:w-full overflow-x-auto">
        <table className="  text-sm whitespace-pre w-full ">
          <thead>
            <tr className="text-left text-sm bg-neutral-100  rounded-sm">
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Etudiant</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Etat</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Date d'inscription</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm ">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredData?.map((items, index) => (
              <tr key={items?.id} className=" border-b border-gray-100 rounded ">
                <td className=" py-3">
                  <div className="flex  ml-5 items-center gap-2 text-start ">
                    <input type="checkbox" name="g" id="" className='w-4 h-4 rounded-lg' />
                     <div className="flex items-center gap-2 p-1.5 w-fit hover:bg-neutral-100 rounded-lg cursor-pointer">
                        <ImageWithFallback src={END_POINT+"/storage"+items?.user?.photo} alt="user1" defaultType='user' className='w-8 h-8 rounded-full' /> 
                        <div className="flex flex-col justify-between  w-fit mr-5 px-4">
                            <p className="text-base font-medium mr-2">{items?.user?.nom}</p>
                            <div className="flex gap-2 text-xs">
                            {items?.user?.email}
                            </div>
                        </div>
                     </div>                    
                  </div>
                </td>
                <td className="pl-5  justify-start">
                      <StatusBadge status={items?.status} />
                </td>
                <td className="pl-5">
                  <p className="text-sm leading-none  text-start flex gap-1 items-center text-primary-text">
                  {formatInDate(items?.created_at)}</p>
                </td>
                <td className="pl-5">
                    <div className="flex  items-center gap-2 text-start ">
                    <DropdownStatusOpt item={items}  setDisplayModal={setStatusOption} onItemSelected={()=>setEnrolmentSelected(items)} key={index}/>
                      <button                     
                        onClick={() =>{ 
                        setEnrolmentSelected(items)
                        setshowModal(true)} }
                        className="relative flex items-center justify-end gap-2 text-base text-neutral-500 font-medium text-dark bg-gray-50 border rounded-md p-2"
                      > 
                        <FaEye/>
                      </button>
                      {/* {items?.id} */}

                    </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <StudentModal show={showModal} onClose={()=>setshowModal(false)} data={enrolmentSelected} item={data} />
      <ConfirmEnrollmentModal show={showConfirmModal} onClose={() => setShowConfirmModal(false)} enrolmentId={enrolmentSelected?.id} />
      <DeclineEnrollmentModal show={showDeclineModal} onClose={() => setShowDeclineModal(false)} enrolmentId={enrolmentSelected?.id} />
    </div>
  )
}

export default Enrollement

// const DropdownFilter = () => {
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [selectedValues, setSelectedValues] = useState({
//     week: "This Week",
//     filter: "Filter",
//     sort: "Sort",
//   });

//   const toggleDropdown = (menu) => {
//     setOpenDropdown(openDropdown === menu ? null : menu);
//   };

//   const handleSelect = (menu, value) => {
//     setSelectedValues((prev) => ({ ...prev, [menu]: value }));
//     setOpenDropdown(null); // Fermer le menu après sélection
//   };

//   return (
//     <div className="flex space-x-2">
//       <Dropdown
//         label={selectedValues.week}
//         icon={<CalendarIcon />}
//         isOpen={openDropdown === "week"}
//         onToggle={() => toggleDropdown("week")}
//       >
//         <DropdownItem text="Today" onClick={() => handleSelect("week", "Today")} />
//         <DropdownItem text="This Week" onClick={() => handleSelect("week", "This Week")} />
//         <DropdownItem text="This Month" onClick={() => handleSelect("week", "This Month")} />
//       </Dropdown>

//       <Dropdown
//         label={selectedValues.filter}
//         icon={<FilterIcon />}
//         isOpen={openDropdown === "filter"}
//         onToggle={() => toggleDropdown("filter")}
//       >
//         <DropdownItem text="By Category" onClick={() => handleSelect("filter", "By Category")} />
//         <DropdownItem text="By Date" onClick={() => handleSelect("filter", "By Date")} />
//         <DropdownItem text="By Status" onClick={() => handleSelect("filter", "By Status")} />
//       </Dropdown>

//       <Dropdown
//         label={selectedValues.sort}
//         icon={<SortIcon />}
//         isOpen={openDropdown === "sort"}
//         onToggle={() => toggleDropdown("sort")}
//       >
//         <DropdownItem text="Ascending" onClick={() => handleSelect("sort", "Ascending")} />
//         <DropdownItem text="Descending" onClick={() => handleSelect("sort", "Descending")} />
//       </Dropdown>
//     </div>
//   );
// };

// ⬇️ Composants réutilisables ⬇️

const Dropdown = ({ label, icon, isOpen, onToggle, children }) => (
  <div className="relative">
    <button
      onClick={onToggle}
      className="flex items-center space-x-2 px-4 py-2 border rounded-lg bg-white shadow-sm hover:bg-gray-100"
    >
      {icon}
      <span>{label}</span>
    </button>
    {isOpen && (
      <div className="absolute mt-2 min-w-[200px] bg-white border rounded-lg shadow-lg p-2 z-[9999]">
        {children}
      </div>
    )}
  </div>
);

const DropdownItem = ({ text, onClick }) => (
  <div onClick={onClick} className="px-4 py-2 cursor-pointer text-start hover:bg-gray-100">
    {text}
  </div>
);


const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const FilterIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 4 21 4 14 12 14 20 10 20 10 12 3 4"></polygon>
  </svg>
);

const SortIcon = () => (
  <svg width="16" height="16" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M384 96a32 32 0 0 1 64 0v786.752a32 32 0 0 1-54.592 22.656L95.936 608a32 32 0 0 1 0-45.312h.128a32 32 0 0 1 45.184 0L384 805.632V96zm192 45.248a32 32 0 0 1 54.592-22.592L928.064 416a32 32 0 0 1 0 45.312h-.128a32 32 0 0 1-45.184 0L640 218.496V928a32 32 0 1 1-64 0V141.248z"/></svg>
);

const SettingsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a2 2 0 0 0 .4 2.2l1.5 1.5a1.5 1.5 0 0 1-2.1 2.1l-1.5-1.5A2 2 0 0 0 15 19.4V22a1.5 1.5 0 0 1-3 0v-2.6a2 2 0 0 0-2.2-.4l-1.5 1.5a1.5 1.5 0 1 1-2.1-2.1l1.5-1.5A2 2 0 0 0 4.6 15H2a1.5 1.5 0 1 1 0-3h2.6a2 2 0 0 0 .4-2.2L3.5 8.5a1.5 1.5 0 0 1 2.1-2.1l1.5 1.5A2 2 0 0 0 9 4.6V2a1.5 1.5 0 0 1 3 0v2.6a2 2 0 0 0 2.2.4l1.5-1.5a1.5 1.5 0 1 1 2.1 2.1l-1.5 1.5a2 2 0 0 0 .4 2.2H22a1.5 1.5 0 1 1 0 3h-2.6z"></path>
  </svg>
);

// export default DropdownButtons;
